import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import certificate1 from "../../assets/acrylic-certificate.jpg";
import certificate2 from "../../assets/polyurethane-certificate.jpg";
import certificate3 from "../../assets/running-track-certificate.jpg";
import certificate4 from "../../assets/iso-9001-certificate.jpg";
import certificate5 from "../../assets/iso-14001-certificate.jpg";
import Modal from "../common/CustomModal";
import { motion } from "framer-motion";

const Certificate = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1060,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  const [clickedAward, setClickedAward] = useState<string | null>(null);
  const awards = [
    certificate1,
    certificate2,
    certificate3,
    certificate4,
    certificate5,
  ];
  return (
    <section className="relative w-full h-full px-[5%] bg-[#f2f3f5ab] border-t border-t-gray-200 py-12 flex justify-center">
      <div className="overflow-hidden slider-container max-w-[286px] xs:max-w-[1200px] mx-auto">
        <Slider {...settings}>
          {awards.map((award, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.99 }}
              transition={{ type: "spring", stiffness: 300 }}
              className="relative overflow-hidden p-2 border-2 rounded-sm max-w-[259px] h-[200px] flex justify-center items-center cursor-pointer hover:shadow-lg m-5"
              onClick={() => setClickedAward(award)}
            >
              <div className="relative flex flex-col h-full p-4 bg-white border border-tertiary">
                <img
                  src={award}
                  className="object-contain w-full h-full max-w-full"
                  alt={`certificate-${index + 1}`}
                />
              </div>
            </motion.div>
          ))}
        </Slider>
      </div>

      <Modal
        isOpen={!!clickedAward}
        onClose={() => setClickedAward(null)}
        size="max-content"
      >
        <img
          src={clickedAward!}
          className="object-contain sm:object-cover max-h-[80vh] w-auto max-w-full"
          alt="certification preview"
        />
      </Modal>
    </section>
  );
};

export default Certificate;
